
import { Component, Vue, Prop } from 'vue-property-decorator'
import { handleFill, moneyFormat } from '@/utils/util';

@Component
export class Category extends Vue {
  @Prop({ default: () => { } }) accountData: any
  @Prop({ default: () => { } }) billData: any
  handleFill = handleFill
  moneyFormat = moneyFormat
}
export default Category
